import {isEventPreview} from '../../../../selectors/navigation'
import {getPreliminaryInvoice} from '../../../../selectors/placed-order'
import {getSelectedTicketsQuantity} from '../../../../selectors/selected-tickets'
import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {SummaryOwnProps, SummaryRuntimeProps} from './interfaces'
import {Summary as Presentation} from './summary'

const mapRuntime = ({state}: DetailsPageAppProps): SummaryRuntimeProps => ({
  selectedTickets: getSelectedTicketsQuantity(state),
  invoice: getPreliminaryInvoice(state),
  eventPreview: isEventPreview(state),
})

export const Summary = connect<SummaryOwnProps, SummaryRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
